import { Download } from "lucide-react";

import DetailsCard from "@/components/details/card";
import { DetailsItemGrid } from "@/components/details/item-grid/grid";

interface ICreditCaseFileBlockProps {
  creditCaseFileUrl: string | null;
  creditCaseFileTitle: string | null;
}

export const CreditCaseFileBlock = ({
  creditCaseFileUrl,
  creditCaseFileTitle,
}: ICreditCaseFileBlockProps) => {
  if (!creditCaseFileUrl) return null;

  const title = creditCaseFileTitle ?? "Open business case";

  return (
    <div className="flex flex-col gap-4">
      <DetailsCard title="Financing - business case">
        <DetailsItemGrid className="!flex flex-col !gap-0">
          <p>
            See more information about the financing need and qualitative
            information in the business case:
          </p>
          <div className="flex items-center gap-3">
            <a href={creditCaseFileUrl} target="_blank" rel="noreferrer">
              {title}
            </a>
            <a
              href={creditCaseFileUrl}
              download={title}
              className="text-black hover:text-black"
            >
              <Download className="size-4" />
            </a>
          </div>
        </DetailsItemGrid>
      </DetailsCard>
    </div>
  );
};
